import { getDY_SR } from "stackerConfig"

const swatchConfig = {
  SWATCH_PDP_HIDE_LIMIT: 1,
  SWATCH_PDP_CAROUSEL_LIMIT: getDY_SR().config.pdp.swatchCarouselLimit,
  SWATCH_MAX_VISIBILE: 7,
  MAGIC_NUMBER: 135,
  MAGIC_NUMBER_EXCEPT: 50,
}

export default swatchConfig
